import React, { useEffect, useState } from "react";
import useMonthlyPayslipStore from "../../../config/stores/administration/useMonthlyPayslipStore";
import { searchTable } from "../../../config/constants";
import TableTitle from "../../../components/common/TableTitle";
import AntdTable from "../../../components/common/AntdTable";
import TableButtonActions from "../../../components/common/TableButtonActions";
import RecordStatus from "../../../components/common/RecordStatus";
import moment from "moment";
import PayslipDetails from "./PayslipDetails";

const MyPayslips = () => {
  const [filterTable, setFilterTableNull] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const payslipStore = useMonthlyPayslipStore();
  const {
    myPayslips,
    getMyPayslips,
    gettingMyPayslips,
    setShowPayslipDetails,
    showPayslipDetails,
    payslipDetailsRecord,
    deletePayslip,
  } = payslipStore;

  const search = (value) => {
    const filterTable = searchTable(myPayslips, value);
    setFilterTableNull(filterTable);
  };

  const confirmDelete = () => {
    deletePayslip(deleteId);
    setDeleteId(null);
  };

  const deleteRecord = (id) => setDeleteId(id);

  const viewDetails = (record) => {
    payslipStore.setShowPayslipDetails(true);
    payslipStore.getPayslipDetails(record.id);
  };

  const refreshTable = () => {
    getMyPayslips();
  };

  useEffect(() => {
    getMyPayslips();
  }, []);

  const columns = [
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
      render: (month) => moment(month, "M").format("MMMM"),
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <RecordStatus status={status} />,
    },
    {
      title: "Net Salary",
      dataIndex: "net_salary",
      key: "net_salary",
      render: (netSalary) => `UGX ${netSalary?.toLocaleString()}`
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <TableButtonActions
          record={record}
          viewDetails={() => viewDetails(record)}
        />
      ),
    },
  ];

  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">MY PAYSLIPS</h5>
     
      {/* Payslip Details */}
      {payslipStore.showPayslipDetails ? <PayslipDetails /> : <>
        <AntdTable
        loading={gettingMyPayslips}
        title={() => (
          <TableTitle
            setFilterTableNull={setFilterTableNull}
            refreshTable={refreshTable}
            search={search}
            exportRecords={null}
            openAddModal={null}
          />
        )}
        pageSize={20}
        data={filterTable === null ? myPayslips || [] : filterTable}
        columns={columns}
      />
      </>}
    </div>
  );
};

export default MyPayslips; 